/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import './team.css';

const allImages = {
  all: {
    label: 'Management Team',
    content: [
      {
        src: require('../images/team/RBSKPhoto.jpg'),
        alt: 'Image 1',
        name: 'RB Santosh Kumar',
        details: `R B Santosh Kumar is a distinguished Indian artist celebrated for his profound creativity and
technical mastery across diverse mediums, including oil, acrylic, and watercolor. With over 30
art exhibitions to his credit, he has established himself as one of India’s most esteemed
contemporary artists. His exceptional talent was recognized in 2023 when he received the award
for the finest contemporary artist in India. A graduate of Harvard Business School, Boston,
Santosh seamlessly blends artistic brilliance with professional acumen. Santosh’s paintings are
known for capturing emotions and moments with unparalleled sensitivity. His artistic versatility
and innovative techniques have earned him widespread acclaim, with some of his works
displayed in prestigious venues, including the Rashtrapati Bhavan, In addition to his artistic
pursuits, Santosh had built a remarkable career in business and financial services holding key
roles at renowned organizations such as the Taj Group of Hotels, Times of India, Standard
Chartered Bank, Citibank, and Mastercard. A recipient of a silver medal from the President of
India, Santosh is also a socially conscious citizen. Through collaborations with NGOs, he
ensures that proceeds from his art exhibitions support the education of underprivileged children,
reflecting his commitment to giving back to society.`,
      },
      // { src: require('../images/team/Rahu Budguzzar Best graffiti public street Artist.jpeg'), alt: 'Rahul', name: 'Rahul Budguzzar' },
    ],
  },
  sculptures: {
    label: 'Artist',
    content: [
      {
        src: require('../images/team/Rahu Budguzzar Best graffiti public street Artist.jpeg'),
        alt: 'Rahul',
        name: 'Rahul Budguzzar',
      },
      {
        src: require('../images/team/Aayush Sharma stone sculpture, silicone, bronze.jpeg'),
        alt: 'Image 2',
        name: 'Ayush Sharma',
      },
      {
        src: require('../images/team/Artist Naresh Kumar speslist portrait Filam banner Bollywood jalandar Punjab 1.jpeg'),
        alt: 'Naresh',
        name: 'Naresh Kumar',
      },
      {
        src: require('../images/team/Yilin Sculp artist china.jpeg'),
        alt: 'Image 2',
        name: 'Yilin Sculp',
      },
    ],
  },
};

function Team() {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
  };

  const handleImageClick = (content) => {
    setSelectedImage(content);
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);
  return (
    <div>
      {/* <nav className="navbar navbar-expand-lg navbar-light bg-light">
                <div className="container-fluid">
                    <div className="collapse navbar-collapse justify-content-center" id="subNavbarNav">
                        <ul className="navbar-nav flex-wrap" style={{ fontSize: '18px', fontWeight: 'bold' }}>
                            {Object.keys(allImages).map((category, index) => (
                                <li className="nav-item" style={{ margin: '5px', fontSize: '16px' }} key={index} >
                                    <button className="nav-link btn btn-link" onClick={() => handleCategoryChange(category)} style={{ marginRight: '20px', textDecoration: selectedCategory === category ? 'underline' : 'none' }}>
                                        {allImages[category].label}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </nav> */}
      <div className="container pt-4" style={{ backgroundColor: '#fafafa' }}>
        <div className="row">
          {allImages[selectedCategory].content.map((content, index) => (
            <div
              className="mb-2 row flex-row align-items-center"
              key={content}
              // onClick={() => handleImageClick(content)}
            >
              <div className="image-container col-4">
                <img
                  src={content.src}
                  alt={content.alt}
                  className="img-fluid"
                  style={{ height: '284px', width: '400px' }}
                />
                <div className="overlay">
                  <i className="fas fa-plus" />
                </div>
                <h4 className="text-center mt-2">{content.name}</h4>
              </div>
              <div className="col-8">
                <span>
                  R B Santosh Kumar is a distinguished Indian artist celebrated
                  for his profound creativity and technical mastery across
                  diverse mediums, including oil, acrylic, and watercolor. With
                  over 30 art exhibitions to his credit, he has established
                  himself as one of India’s most esteemed contemporary artists.
                  His exceptional talent was recognized in 2023 when he received
                  the award for the finest contemporary artist in India. A
                  graduate of Harvard Business School, Boston, Santosh
                  seamlessly blends artistic brilliance with professional
                  acumen. Santosh’s paintings are known for capturing emotions
                  and moments with unparalleled sensitivity. His artistic
                  versatility and innovative techniques have earned him
                  widespread acclaim, with some of his works displayed in
                  prestigious venues, including the Rashtrapati Bhavan, In
                  addition to his artistic pursuits, Santosh had built a
                  remarkable career in business and financial services holding
                  key roles at renowned organizations such as the Taj Group of
                  Hotels, Times of India, Standard Chartered Bank, Citibank, and
                  Mastercard. A recipient of a silver medal from the President
                  of India, Santosh is also a socially conscious citizen.
                  Through collaborations with NGOs, he ensures that proceeds
                  from his art exhibitions support the education of
                  underprivileged children, reflecting his commitment to giving
                  back to society.
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Modal Pop-up */}
      <Modal show={showModal} onHide={handleCloseModal} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>{selectedImage?.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="d-flex">
          <img
            src={selectedImage?.src}
            alt={selectedImage?.alt}
            className="img-fluid"
            style={{ height: '350px', marginRight: '20px', width: '400px' }}
          />
          <div>
            <h5>Details:</h5>
            <p>{selectedImage?.details}</p>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default Team;
